import React, { useState } from 'react';

import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ZeosInput } from './ZeosInput'; // Assuming ZeosInput is a custom input component

interface IProps {
  autoComplete?: string;
  error?: string;
  isVisible?: boolean;
  label: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  showRules?: boolean;
  syncVisibility?: boolean;
  toggleVisibility?: () => void;
  value: string;
  required?: boolean;
}

export const ZeosPasswordInput = (props: IProps) => {
  const {
    autoComplete,
    error,
    isVisible,
    label,
    name,
    onChange,
    onBlur,
    placeholder,
    showRules = false,
    syncVisibility = false,
    toggleVisibility,
    value,
    required = false,
  } = props;

  const [localVisible, setLocalVisible] = useState(false);
  const visible = syncVisibility ? isVisible : localVisible;

  const handleToggle = () => {
    if (syncVisibility && toggleVisibility) toggleVisibility();
    else setLocalVisible(!localVisible);
  };

  return (
    <div className="relative">
      <ZeosInput
        name={name}
        label={label}
        type={visible ? "text" : "password"}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        placeholder={placeholder}
        required={required}
      />
      <button
        type="button"
        onClick={handleToggle}
        aria-label={visible ? "Hide password" : "Show password"}
        aria-pressed={visible}
        title={visible ? "Hide password" : "Show password"}
        className="absolute top-12 right-4 cursor-pointer text-zeos-grey-md focus:outline-none focus:ring-2 focus:ring-zeos-blue"
      >
        <FontAwesomeIcon
          icon={visible ? faEye : faEyeSlash}
          className="text-2xl"
        />
      </button>
      {showRules && name === "password" && (
        <div className="text-xs text-zeos-grey-md mt-1  pl-5 space-y-1">
          <p>
            8 or more characters with at least one uppercase, lowercase, numeric
            and special character
          </p>
        </div>
      )}
    </div>
  );
};
